<template lang="html">
	<div id="text-page">
		<div class="container">
			<h1 class="mb-2 page-title">{{ 'aviso-de-privacidad' | static-title }}</h1>
			<static-markdown :content="'aviso-de-privacidad' | static-content"></static-markdown>
		</div>
	</div>
</template>

<script>
export default {
	name: 'aviso',
}
</script>
